import React from 'react'
export const Status = {
    LOADING: 'Loading',
    FAILED_TO_LOAD: 'Failed to Load',
    LOADED: 'Loaded',
    ABORTED: 'Aborted',
    UNAVAILABLE: 'Unavailable',
    NULL: 'Null',
}

export const Loading = ({status, spinner=true, error, children}) => (
    <React.Fragment>{
    status === Status.LOADING && spinner ? (
        <div style={{minWidth:'150px'}}>
        <div
            data-name="loading-spinner"
            className="spinner"
            style={{ width:"45px", minHeight:"100px", verticalAlign:"top"  }}>
        <svg className="circular" viewBox="25 25 50 50">
            <circle className="background" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
            <circle className="path" cx="50" cy="50" fill="none" r="20" strokeMiterlimit="10" strokeWidth="2"></circle>
        </svg>
        </div>
        </div>
    ) :
    status === Status.FAILED_TO_LOAD ? (
        <div
            data-name="loading-fail"
            className="universal-message universal-message-danger">
        <div className="universal-message-content">
        <h4 className="universal-message-heading text-left"
            dangerouslySetInnerHTML={{__html: error || 'Fails to retrieve data' }}
            />
        </div>
        </div>
    ) :
    status === Status.UNAVAILABLE ? (
        <div
            data-name="loading-unavailable"
            className="universal-message">
        <div className="universal-message-content">
        <h4 className="universal-message-heading text-muted"
            dangerouslySetInnerHTML={{__html: error || 'Unavailable' }}
            />
        </div>
        </div>
    ) :
    status === Status.NULL ? (
        null
    ) :
    status === Status.LOADED ? (
        <React.Fragment>{children}</React.Fragment>
    ) : (
        <React.Fragment>{children}</React.Fragment>
    )
    }</React.Fragment>)
